export default __webpack_public_path__ + "static/media/home-archive.30f5c90d.svg";